"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = {
  additionalConverters: {},
  refPointerPrefix: '#/definitions/'
};